import { FontSizes, Radius } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  titleContainer: {
    width: '100%',
    height: 24,
    backgroundColor: 'rgb(84, 88, 105, .7)',
    borderRadius: `0 0 ${Radius.r16} ${Radius.r16}`,
  },
  sizeTitle: {
    fontWeight: 600,
    fontSize: FontSizes.s10,
    color: 'rgba(255, 255, 255)',
  },
  arrowRight: {
    width: 16,
    height: 16,
    '& path': {
      fill: '#ffffff',
    },
  },
});

export default useStyles;
